import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="bg-forest noise relative min-h-screen grid place-items-center px-4">
      <div className="max-w-md w-full bg-cream rounded-3xl p-10 text-center shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)]" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 text-bad mx-auto mb-5" />
        <h1 className="font-display font-extrabold uppercase text-forest text-3xl">Payment cancelled</h1>
        <p className="text-sm text-sub mt-3 mb-7">
          No charge was made. Your cart is still loaded — pick up right where you left off.
        </p>
        <div className="space-y-3">
          <Link to="/checkout" data-testid="cancel-back-to-checkout" className="block bg-flame hover:bg-ember text-white font-display font-semibold uppercase tracking-wide px-6 py-3.5 rounded-full transition-colors">Back to Checkout</Link>
          <Link to="/shop" className="block border-2 border-forest text-forest hover:bg-forest hover:text-cream font-display font-semibold uppercase tracking-wide px-6 py-3.5 rounded-full transition-colors">Keep Shopping</Link>
        </div>
      </div>
    </div>
  );
}
